export enum ScrollDirection {
  DOWN = 1,
  UP = -1,
  UNKNOWN = 0
}
export enum HorizontalScrollDirection {
  LEFT = 'left',
  RIGHT = 'right'
}

export type Direction = 'horizontal' | 'vertical'
